import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from 'styled-components';
import { themeNames } from '@upgrade/themes';
import { Direction } from '../Logo/constants';
import DefaultLink from '../Link';
import Logo from '../Logo';
import { LogoSwitcher } from './styles';
const getLogoVariation = (theme, color) => {
  const isUniversal = theme && theme.name === themeNames.UNIVERSAL_CREDIT_THEME_NAME;
  const ariaProps = {
    role: 'img',
    'aria-label': `${theme.brandName} Logo`
  };
  if (isUniversal) {
    const universalColor = color === theme.palette.actionablePrimary ? 'dark' : 'light';
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Logo, _extends({
      direction: Direction.compact,
      width: "40px",
      height: "40px",
      color: universalColor
    }, ariaProps)), /*#__PURE__*/React.createElement(Logo, _extends({
      width: "18.8125rem",
      height: "2.5rem",
      color: universalColor
    }, ariaProps)), /*#__PURE__*/React.createElement(Logo, _extends({
      width: "18.8125rem",
      height: "2.5rem",
      color: universalColor
    }, ariaProps)));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Logo, _extends({
    outline: true,
    viewBox: "0 0 40 40",
    width: "22px",
    height: "24px",
    color
  }, ariaProps)), /*#__PURE__*/React.createElement(Logo, _extends({
    outline: true,
    color
  }, ariaProps)), /*#__PURE__*/React.createElement(Logo, _extends({
    color
  }, ariaProps)));
};
export default function HeaderLogo({
  href,
  onClick,
  Link = DefaultLink,
  white = false,
  smWhite = false,
  linkProps,
  logoMobileLarge = false,
  customLogo
}) {
  const theme = useTheme();
  const color = white ? theme.palette.contentReverse : theme.palette.actionablePrimary;
  const logo = customLogo || getLogoVariation(theme, color);

  // add aria-label only if the logo is a link
  const linkAriaProps = {
    'aria-label': href || onClick ? `${theme.brandName} Homepage` : undefined
  };
  return /*#__PURE__*/React.createElement(Link, _extends({
    className: "header__logo"
  }, linkProps, {
    href,
    onClick,
    reverseFocus: white
  }, linkAriaProps), /*#__PURE__*/React.createElement(LogoSwitcher, {
    $logoMobileLarge: logoMobileLarge,
    $smWhite: smWhite
  }, logo));
}
HeaderLogo.propTypes = {
  href: PropTypes.string,
  onClick: PropTypes.func,
  white: PropTypes.bool,
  smWhite: PropTypes.bool,
  Link: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),
  // eslint-disable-next-line react/forbid-prop-types
  linkProps: PropTypes.object,
  logoMobileLarge: PropTypes.bool
};
//# sourceMappingURL=logo.js.map